import Footer from "../components/footer";
import Navbar from "../components/navbar";
import Troubleshooting from "../components/troubleshooting";

function Troubleshoot()
{
    return(
<>

        <Navbar />
        <Troubleshooting/>
        <Footer/>

</>            

    );
}
export default Troubleshoot;